import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import path from 'path';
import classNames from 'classnames';
import {allNoteTypes, systemFilterTypes, getActionType, typeEventFilters} from 'helpers/timelineConstants';
import {TimelineType} from 'models/enums/timeline';
import getIconName from 'helpers/timelineGetIcon';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';

import branchApi from 'api/branch';
import Timeline from 'models/timeline';
import {systemTypeNamesFormat} from 'helpers/constants';
import timlineGetDesc from 'helpers/timelineGetDescription';

class TimelineEvent extends React.Component {
  static defaultProps = {
    event: new Timeline({}),
    color: '#0094d6',
    currentCustomerContacts: [],
    link: null,
  };
  static displayName = 'TimelineEvent';

  static propTypes = {
    event: PropTypes.object,
    color: PropTypes.string,
    scroll: PropTypes.any,
    currentCustomerContacts: PropTypes.any,
    link: PropTypes.string,
    onLastShow: PropTypes.any,
    intl: intlShape.isRequired,
  };

  static initialState = {
    inViewPort: true,
    position: null,
    calledLastShow: false,
    branch: {},
  };

  state = TimelineEvent.initialState;

  componentWillMount() {
    const {event} = this.props;

    if (event.branchID) {
      branchApi.getBranch(event.branchID)
        .then(b => {
          this.setState({
            branch: b,
          });
        });
    }
  }

  componentDidMount() {
    this.setState({
      inViewPort: this.isInViewport(this.event),
    });
  }

  componentDidUpdate(prevProps) {
    //On scroll check if coming into view and the show
    if (prevProps.scroll === this.props.scroll) {
      return;
    }

    const newViewPort = this.isInViewport(this.event);

    if (newViewPort && !this.state.inViewPort) {
      this.setState({
        inViewPort: newViewPort,
      });
    }

    // If last element in list is in view port, tell parent it has render so it can call api to get more
    if (newViewPort === true && this.props.onLastShow && this.state.calledLastShow === false) {
      this.setState({
        calledLastShow: true,
      });
      this.props.onLastShow();
    }
  }

  componentWillUnmount() {
    this.setState(TimelineEvent.initialState);
  }

  isInViewport = element => {
    const rect = element.getBoundingClientRect();
    const html = document.documentElement;

    return rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || html.clientHeight) &&
      rect.right <= (window.innerWidth || html.clientWidth);
  };

  render() {
    const {event, color, link, intl} = this.props;
    const {formatMessage, locale} = intl;

    return <div ref={r => this.event = r}
                className={classNames('cd-timeline-block', {
                  'visibility-visible': this.state.inViewPort,
                  'visibility-hidden': !this.state.inViewPort,
                })}>
      <div className={'cd-timeline-img cd-picture '}
           style={{backgroundColor: color}}>
        <i className={'icon bl bl-' + getIconName(event.type)}/>
      </div>
      <div className="cd-timeline-content">
        <div className='top'>
          <div className='title'
               style={{color: color}}>
            {event.data ?
              event.type === TimelineType.BecameTruBlu || event.type === TimelineType.RemovedTruBlu ?
                <FormattedMessage id='trublue.promise'/> :
                typeEventFilters.find(x => x.types.includes(event.type)).label :
              null}
              &nbsp;
            {getActionType(event.action)}
          </div>
          {systemFilterTypes.includes(event.type) ?
            <div className='type'
                 style={{color: color}}>
              {event.data ?
                systemTypeNamesFormat(formatMessage)[event.data.data.TypeID || event.data.data.PoolTypeID] :
                null}
            </div> :
            null}
          {allNoteTypes.includes(event.type) ?
            <i className={'pointer fa-2x bl ' + (event.data && event.data.data.Flag ? 'bl-flag-filled' : 'bl-flag')}/> :
            null}
        </div>
        <div className='changed-by'
             style={{color: color}}>
          {event.type === TimelineType.Product ?
            this.state.branch.name || '' :
            this.state.branch.name ?
              <FormattedMessage id='customer.timeline.branch.user' values={{user: event.userEmail, branch: this.state.branch.name}} /> :
              <FormattedMessage id='customer.timeline.user' values={{user: event.userEmail}} />}
        </div>
        <div className='event-body'>
          {timlineGetDesc(event, this.state.branch, this.props.currentCustomerContacts, formatMessage)}
        </div>
        <span className="cd-date">
          {moment().locale(locale).format('ll') === moment(event.created).locale(locale).format('ll') ?
            <div className='time'>{moment(event.created).locale(locale).format('h:mm a')}</div> :
            <div>
              <div className='date'>{moment(event.created).locale(locale).format('ll')}</div>
              <div className='time'>{moment(event.created).locale(locale).format('h:mm a')}</div>
            </div>}
        </span>
        {link ?
          <div className='additonal-link'>
            <button className='btn'
                    onClick={() => window.location.hash = path.join(link)}>
              <FormattedMessage id="customer.timeline.event.details"/>
            </button>
          </div> :
          null}
      </div>
    </div>;
  }
}

export default injectIntl(TimelineEvent);
